

import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { AuthProvider } from "./Context/AuthContext";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { luxuryTheme } from "./theme/luxuryTheme";
import CountryLanguageGate from "./components/CountryLanguageGate"; // ✅ add

function App() {
  return (
    <ThemeProvider theme={luxuryTheme}>
      <CssBaseline />
      <AuthProvider>
        <BrowserRouter>
          <CountryLanguageGate /> {/* ✅ يظهر أول ما يدخل */}
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
